/*!
 * JavaScript Custom Forms
 *
 * Copyright 2014-2016 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.2.3
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    root.jcf = factory(jQuery);
  }
}(this, ($) => {
  // define version
  const version = '1.2.3';

  // private variables
  const customInstances = [];

  // default global options
  const commonOptions = {
    optionsKey: 'jcf',
    dataKey: 'jcf-instance',
    rtlClass: 'jcf-rtl',
    focusClass: 'jcf-focus',
    pressedClass: 'jcf-pressed',
    disabledClass: 'jcf-disabled',
    hiddenClass: 'jcf-hidden',
    resetAppearanceClass: 'jcf-reset-appearance',
    unselectableClass: 'jcf-unselectable',
  };

  // detect device type
  const isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch;
  const isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent);
  commonOptions.isMobileDevice = !!(isTouchDevice || isWinPhoneDevice);

  // create global stylesheet if custom forms are used
  const createStyleSheet = function () {
    const styleTag = $('<style>').appendTo('head');
    const styleSheet = styleTag.prop('sheet') || styleTag.prop('styleSheet');

    // crossbrowser style handling
    const addCSSRule = function (selector, rules, index) {
      index = index || 0;
      if (styleSheet.insertRule) {
        styleSheet.insertRule(`${selector}{${rules}}`, index);
      } else {
        styleSheet.addRule(selector, rules, index);
      }
    };

    // add special rules
    addCSSRule(`.${commonOptions.hiddenClass}`, 'position:absolute !important;left:-9999px !important;height:1px !important;width:1px !important;margin:0 !important;border-width:0 !important;-webkit-appearance:none;-moz-appearance:none;appearance:none');
    addCSSRule(`.${commonOptions.rtlClass} .${commonOptions.hiddenClass}`, 'right:-9999px !important; left: auto !important');
    addCSSRule(`.${commonOptions.unselectableClass}`, '-webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-tap-highlight-color: rgba(0,0,0,0);');
    addCSSRule(`.${commonOptions.resetAppearanceClass}`, 'background: none; border: none; -webkit-appearance: none; appearance: none; opacity: 0; filter: alpha(opacity=0);');

    // detect rtl pages
    const html = $('html'); const
      body = $('body');
    if (html.css('direction') === 'rtl' || body.css('direction') === 'rtl') {
      html.addClass(commonOptions.rtlClass);
    }

    // handle form reset event
    html.on('reset', () => {
      setTimeout(() => {
        api.refreshAll();
      }, 0);
    });

    // mark stylesheet as created
    commonOptions.styleSheetCreated = true;
  };

  // simplified pointer events handler
  (function () {
    const pointerEventsSupported = navigator.pointerEnabled || navigator.msPointerEnabled;
    const touchEventsSupported = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch;
    let eventList; const eventMap = {}; const
      eventPrefix = 'jcf-';

    // detect events to attach
    if (pointerEventsSupported) {
      eventList = {
        pointerover: navigator.pointerEnabled ? 'pointerover' : 'MSPointerOver',
        pointerdown: navigator.pointerEnabled ? 'pointerdown' : 'MSPointerDown',
        pointermove: navigator.pointerEnabled ? 'pointermove' : 'MSPointerMove',
        pointerup: navigator.pointerEnabled ? 'pointerup' : 'MSPointerUp',
      };
    } else {
      eventList = {
        pointerover: 'mouseover',
        pointerdown: `mousedown${touchEventsSupported ? ' touchstart' : ''}`,
        pointermove: `mousemove${touchEventsSupported ? ' touchmove' : ''}`,
        pointerup: `mouseup${touchEventsSupported ? ' touchend' : ''}`,
      };
    }

    // create event map
    $.each(eventList, (targetEventName, fakeEventList) => {
      $.each(fakeEventList.split(' '), (index, fakeEventName) => {
        eventMap[fakeEventName] = targetEventName;
      });
    });

    // jQuery event hooks
    $.each(eventList, (eventName, eventHandlers) => {
      eventHandlers = eventHandlers.split(' ');
      $.event.special[eventPrefix + eventName] = {
        setup() {
          const self = this;
          $.each(eventHandlers, (index, fallbackEvent) => {
            if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, false);
            else self[`on${fallbackEvent}`] = fixEvent;
          });
        },
        teardown() {
          const self = this;
          $.each(eventHandlers, (index, fallbackEvent) => {
            if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, false);
            else self[`on${fallbackEvent}`] = null;
          });
        },
      };
    });

    // check that mouse event are not simulated by mobile browsers
    let lastTouch = null;
    const mouseEventSimulated = function (e) {
      const dx = Math.abs(e.pageX - lastTouch.x);
      const dy = Math.abs(e.pageY - lastTouch.y);
      const rangeDistance = 25;

      if (dx <= rangeDistance && dy <= rangeDistance) {
        return true;
      }
    };

    // normalize event
    var fixEvent = function (e) {
      const origEvent = e || window.event;
      let touchEventData = null;
      const targetEventName = eventMap[origEvent.type];

      e = $.event.fix(origEvent);
      e.type = eventPrefix + targetEventName;

      if (origEvent.pointerType) {
        switch (origEvent.pointerType) {
          case 2: e.pointerType = 'touch'; break;
          case 3: e.pointerType = 'pen'; break;
          case 4: e.pointerType = 'mouse'; break;
          default: e.pointerType = origEvent.pointerType;
        }
      } else {
        e.pointerType = origEvent.type.substr(0, 5); // "mouse" or "touch" word length
      }

      if (!e.pageX && !e.pageY) {
        touchEventData = origEvent.changedTouches ? origEvent.changedTouches[0] : origEvent;
        e.pageX = touchEventData.pageX;
        e.pageY = touchEventData.pageY;
      }

      if (origEvent.type === 'touchend') {
        lastTouch = { x: e.pageX, y: e.pageY };
      }
      if (e.pointerType === 'mouse' && lastTouch && mouseEventSimulated(e)) {

      } else {
        return ($.event.dispatch || $.event.handle).call(this, e);
      }
    };
  }());

  // custom mousewheel/trackpad handler
  (function () {
    const wheelEvents = ('onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll').split(' ');
    const shimEventName = 'jcf-mousewheel';

    $.event.special[shimEventName] = {
      setup() {
        const self = this;
        $.each(wheelEvents, (index, fallbackEvent) => {
          if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, false);
          else self[`on${fallbackEvent}`] = fixEvent;
        });
      },
      teardown() {
        const self = this;
        $.each(wheelEvents, (index, fallbackEvent) => {
          if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, false);
          else self[`on${fallbackEvent}`] = null;
        });
      },
    };

    var fixEvent = function (e) {
      const origEvent = e || window.event;
      e = $.event.fix(origEvent);
      e.type = shimEventName;

      // old wheel events handler
      if ('detail' in origEvent) {
        e.deltaY = -origEvent.detail;
      }
      if ('wheelDelta' in origEvent) {
        e.deltaY = -origEvent.wheelDelta;
      }
      if ('wheelDeltaY' in origEvent) {
        e.deltaY = -origEvent.wheelDeltaY;
      }
      if ('wheelDeltaX' in origEvent) {
        e.deltaX = -origEvent.wheelDeltaX;
      }

      // modern wheel event handler
      if ('deltaY' in origEvent) {
        e.deltaY = origEvent.deltaY;
      }
      if ('deltaX' in origEvent) {
        e.deltaX = origEvent.deltaX;
      }

      // handle deltaMode for mouse wheel
      e.delta = e.deltaY || e.deltaX;
      if (origEvent.deltaMode === 1) {
        const lineHeight = 16;
        e.delta *= lineHeight;
        e.deltaY *= lineHeight;
        e.deltaX *= lineHeight;
      }

      return ($.event.dispatch || $.event.handle).call(this, e);
    };
  }());

  // extra module methods
  const moduleMixin = {
    // provide function for firing native events
    fireNativeEvent(elements, eventName) {
      $(elements).each(function () {
        const element = this; let
          eventObject;
        if (element.dispatchEvent) {
          eventObject = document.createEvent('HTMLEvents');
          eventObject.initEvent(eventName, true, true);
          element.dispatchEvent(eventObject);
        } else if (document.createEventObject) {
          eventObject = document.createEventObject();
          eventObject.target = element;
          element.fireEvent(`on${eventName}`, eventObject);
        }
      });
    },
    // bind event handlers for module instance (functions beggining with "on")
    bindHandlers() {
      const self = this;
      $.each(self, (propName, propValue) => {
        if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
          // dont use $.proxy here because it doesn't create unique handler
          self[propName] = function () {
            return propValue.apply(self, arguments);
          };
        }
      });
    },
  };

  // public API
  var api = {
    version,
    modules: {},
    getOptions() {
      return $.extend({}, commonOptions);
    },
    setOptions(moduleName, moduleOptions) {
      if (arguments.length > 1) {
        // set module options
        if (this.modules[moduleName]) {
          $.extend(this.modules[moduleName].prototype.options, moduleOptions);
        }
      } else {
        // set common options
        $.extend(commonOptions, moduleName);
      }
    },
    addModule(proto) {
      // proto is factory function
      if ($.isFunction(proto)) {
        proto = proto($, window);
      }

      // add module to list
      const Module = function (options) {
        // save instance to collection
        if (!options.element.data(commonOptions.dataKey)) {
          options.element.data(commonOptions.dataKey, this);
        }
        customInstances.push(this);

        // save options
        this.options = $.extend({}, commonOptions, this.options, getInlineOptions(options.element), options);

        // bind event handlers to instance
        this.bindHandlers();

        // call constructor
        this.init.apply(this, arguments);
      };

      // parse options from HTML attribute
      var getInlineOptions = function (element) {
        const dataOptions = element.data(commonOptions.optionsKey);
        const attrOptions = element.attr(commonOptions.optionsKey);

        if (dataOptions) {
          return dataOptions;
        } if (attrOptions) {
          try {
            return $.parseJSON(attrOptions);
          } catch (e) {
            // ignore invalid attributes
          }
        }
      };

      // set proto as prototype for new module
      Module.prototype = proto;

      // add mixin methods to module proto
      $.extend(proto, moduleMixin);
      if (proto.plugins) {
        $.each(proto.plugins, (pluginName, plugin) => {
          $.extend(plugin.prototype, moduleMixin);
        });
      }

      // override destroy method
      const originalDestroy = Module.prototype.destroy;
      Module.prototype.destroy = function () {
        this.options.element.removeData(this.options.dataKey);

        for (let i = customInstances.length - 1; i >= 0; i--) {
          if (customInstances[i] === this) {
            customInstances.splice(i, 1);
            break;
          }
        }

        if (originalDestroy) {
          originalDestroy.apply(this, arguments);
        }
      };

      // save module to list
      this.modules[proto.name] = Module;
    },
    getInstance(element) {
      return $(element).data(commonOptions.dataKey);
    },
    replace(elements, moduleName, customOptions) {
      const self = this;
      let instance;

      if (!commonOptions.styleSheetCreated) {
        createStyleSheet();
      }

      $(elements).each(function () {
        let moduleOptions;
        const element = $(this);

        instance = element.data(commonOptions.dataKey);
        if (instance) {
          instance.refresh();
        } else {
          if (!moduleName) {
            $.each(self.modules, (currentModuleName, module) => {
              if (module.prototype.matchElement.call(module.prototype, element)) {
                moduleName = currentModuleName;
                return false;
              }
            });
          }
          if (moduleName) {
            moduleOptions = $.extend({ element }, customOptions);
            instance = new self.modules[moduleName](moduleOptions);
          }
        }
      });
      return instance;
    },
    refresh(elements) {
      $(elements).each(function () {
        const instance = $(this).data(commonOptions.dataKey);
        if (instance) {
          instance.refresh();
        }
      });
    },
    destroy(elements) {
      $(elements).each(function () {
        const instance = $(this).data(commonOptions.dataKey);
        if (instance) {
          instance.destroy();
        }
      });
    },
    replaceAll(context) {
      const self = this;
      $.each(this.modules, (moduleName, module) => {
        $(module.prototype.selector, context).each(function () {
          if (this.className.indexOf('jcf-ignore') < 0) {
            self.replace(this, moduleName);
          }
        });
      });
    },
    refreshAll(context) {
      if (context) {
        $.each(this.modules, (moduleName, module) => {
          $(module.prototype.selector, context).each(function () {
            const instance = $(this).data(commonOptions.dataKey);
            if (instance) {
              instance.refresh();
            }
          });
        });
      } else {
        for (let i = customInstances.length - 1; i >= 0; i--) {
          customInstances[i].refresh();
        }
      }
    },
    destroyAll(context) {
      if (context) {
        $.each(this.modules, (moduleName, module) => {
          $(module.prototype.selector, context).each((index, element) => {
            const instance = $(element).data(commonOptions.dataKey);
            if (instance) {
              instance.destroy();
            }
          });
        });
      } else {
        while (customInstances.length) {
          customInstances[0].destroy();
        }
      }
    },
  };

  // we need to make JCF available globally if we're in AMD environment
  if (typeof define === 'function' && define.amd) {
    window.jcf = api;
  }

  return api;
}));
